export default function clearCompletedWordsCache(){
	return {
		type: 'CLEAR_COMPLETED_WORDS_CACHE',
	}
}


// WEBPACK FOOTER //
// ./src/actions/clearCompletedWordsCache.js